import { type PrinterOptions } from "qz-tray";

import { qz } from "../client";
import { type Listener } from "../connection/types";
import { type ConfigDefaultsState } from "./types";

/**
 * `qz-tray` has no `getDefaults` accessor, so we mirror the last-set value
 * into a tiny external store for `useConfigDefaults` to observe. Callers that
 * bypass `setConfigDefaults` and hit `qz.configs.setDefaults` directly will
 * silently de-sync — `setConfigDefaults` is the only correct entry point.
 */
const listeners = new Set<Listener>();

let state: ConfigDefaultsState = { defaults: null };

const emit = () => {
  for (const listener of listeners) listener();
};

export const subscribeConfigDefaults = (listener: Listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const getConfigDefaultsSnapshot = () => state;

export const setConfigDefaults = (options: PrinterOptions) => {
  qz.configs.setDefaults(options);
  state = { defaults: options };
  emit();
};
